import serverFetch from './ServerFetch';
import { usePromoMessagesStore } from '../stores/promoMessages';
import { useImportantMessageStore } from '../stores/importantMessage';
import { useCustomerRfpListStore } from '../stores/customerRfpList';
import { useUserStore } from '../stores/user';
import { useAppStore } from '../stores/app';
import { TutorialVideo, useCustomerOnboardingStore } from '../stores/customerOnboarding';
import { useBuyerMessagesStore } from '../stores/buyerMessagesStore';

export interface HelloResponseUser {
	idUser: number;
	idCustomer: number;
	badges: string[];
	hasPhotos: boolean;
	hasDescription: boolean;
	hasMarks: boolean;
	yearsOnMarket: number;
	placedOffersCount: number;
	canShowImportantMessage: boolean;
	boxes: any;
	passwordSet?: string;
	buyerViewNew?: string;
	phoneConfirmed?: string;
	avatar: string;
	firstName: string;
	lastName: string;
	phone: string;
	companyName: string;
	email: string;
	profileUrl: string;
	bestUrl: string;
	sex: 'MALE' | 'FEMALE' | 'NEUTRAL';
	isAuth: boolean;
	nip: { country: string, value: string, isIndividual: boolean };
	isPartner: boolean;
	city: string;
	switchedToUsername: string;
	lastRfpCity: string;
	abTestContinueInMobileApp: boolean;
	videos?: { [key: string]: TutorialVideo; };
}

export interface HelloResponse {
	onboarding?: {
		onboardingSteps: { name: string; percentageValue: number; }[];
		allowDisablingGoodMorning: boolean;
	};
	flags: string[];
	user?: HelloResponseUser;
	apImportantMessage?: string;
	role?: string;
	canShowImportantMessage?: string;
	allRoles?: string[];
	baseUrl?: string;
	status: string;
	error?: string;
	sessionId: string;
	baseWebsocketUrl?: string;
	facebook?: string;
	ua?: string;
	newMessagesSinceLastVisit?: boolean;
	userComApiKey?: string;
	analytics?: any;
	importantMessage?: {
		id: number;
		type: 'success' | 'info' | 'danger' | 'alert';
		title: string;
		message: string;
		buttonLabel: string;
		dismissButtonLabel: string;
		moreInfoLink: string;
	};
	expressSpecialist?: boolean;
	reversalLimit?: number;
	profileCompletness?: number;
	accountBalance?: number;
	maxCategoryPrice?: number;
	abTestContinueInMobileApp?: boolean;
	isShowGoogleLogin?: boolean;
	isBranchIoQrLoginOnlyForOferteoEmail?: boolean;
	frontEndDebug?: boolean;
}

export default class ServerManager {
	static GetUser(rsvp: HelloResponse, user?: HelloResponseUser) {
		if (!user) {
			return {
				UserId: 0,
				CustomerId: 0,

				IsCustomer: false,
				isExpressSpecialist: false,
				Role: '',
				AllRoles: [],
				isAuth: false,

				FirstName: '',
				LastName: '',
				CompanyName: '',
				Phone: '',
				Email: '',
				City: '',
				Avatar: '',
				Nip: { country: 'PL', value: '', isIndividual: false },

				abTestContinueInMobileApp: false,
				isShowGoogleLogin: rsvp.isShowGoogleLogin,

				isContinueInAppEnabledOnlyForOferteo: rsvp.isBranchIoQrLoginOnlyForOferteoEmail,

				frontEndDebug: rsvp.frontEndDebug,
			};
		}

		return {
			UserId: user.idUser,
			CustomerId: user.idCustomer,

			IsCustomer: rsvp.role === 'ADMIN' || rsvp.role === 'CUSTOMER',
			isExpressSpecialist: rsvp.expressSpecialist,
			Role: rsvp.role,
			AllRoles: rsvp.allRoles,
			isAuth: user.isAuth,

			FirstName: user.firstName,
			LastName: user.lastName,
			CompanyName: user.companyName,
			Phone: user.phone,
			Email: user.email,
			City: user.city || '',
			Avatar: (user.avatar || '').indexOf('images/hero') > -1 ? '' : user.avatar,
			Nip: user.nip || { country: 'PL', value: '', isIndividual: false },
			LastRfpCity: user.lastRfpCity,

			abTestContinueInMobileApp: user.abTestContinueInMobileApp,
			isShowGoogleLogin: rsvp.isShowGoogleLogin,

			isContinueInAppEnabledOnlyForOferteo: rsvp.isBranchIoQrLoginOnlyForOferteoEmail,
		};
	}

	Hello(allowNotCustomers:boolean) {
		return new Promise(async (resolve, reject) => {
			const { pathname } = document.location;
			const pathSegments = pathname.split('/');
			let query = document.location.search;

			// initchat when request is from email link and user is not logged in
			// link structure from email => "moje-zapytania/rfp/:rfpId/:chatId/czat?obj=xxxxxx..."
			if (query.search('obj=') > -1 && pathname.search('moje-zapytania/rfp') && pathname.search('konto') === -1) {
				await this.Fetch(`/rfp-json/init-chat.ofer?rfpId=${pathSegments[3]}&cid=${pathSegments[4]}&${query.substring(1)}`);
			}

			const { href } = window.location;

			if (href.search('zapytania') === -1 && href.search('kontakty') === -1 && !href.endsWith('/konto/') && !href.endsWith('/konto')) {
				query = `?disableOnboarding=true${query}`;

				if (query.search('disableOnboarding=true?') > -1) {
					query = query.replace('disableOnboarding=true?', 'disableOnboarding=true&');
				}
			}

			let rsvp: HelloResponse = {
				baseUrl: document.location.hostname,
				flags: [],
				error: 'NOT_AUTH',
				status: 'ERROR',
				sessionId: '',
			};

			if (query.indexOf('asUnlogged=true') === -1) {
				const isBuyerApp = window.localStorage.getItem('isBuyerApp') === 'true';
				rsvp = await serverFetch(`/profile/hello.ofer${query}`);
				if (isBuyerApp && rsvp.error === 'NOT_AUTH') {
					rsvp = await serverFetch(`/profile/hello.ofer${query}`, {}, 'POST');
				}
			}

			if (rsvp.role === 'PARTNER') {
				document.location.href = '/myoferteo/program-partnerski/statystyki';
				reject(rsvp);
				return;
			}

			const User = ServerManager.GetUser(rsvp, rsvp.user);

			const appStore = useAppStore();
			appStore.sessionId = rsvp.sessionId;

			const userStore = useUserStore();
			userStore.update(rsvp);
			if (User.IsCustomer) {
				const promoMessagesStore = usePromoMessagesStore();
				await promoMessagesStore.update();

				const importantMessageStore = useImportantMessageStore();
				importantMessageStore.update(rsvp);

				const customerRfpListStore = useCustomerRfpListStore();
				await customerRfpListStore.updateAdditionalBoxes();
				customerRfpListStore.updateFlags(rsvp.flags);

				const customerOnboardingStore = useCustomerOnboardingStore();
				customerOnboardingStore.update(rsvp);
			}

			if (User.Role === 'BUYER' && query.indexOf('formularz') === -1) {
				const buyerMessagesStore = useBuyerMessagesStore();
				await buyerMessagesStore.update();
				await buyerMessagesStore.checkIfBellIsRinging();
			}
			appStore.update(rsvp);
			resolve({
				User,
				needsLogin: !((rsvp.role && rsvp.role !== 'BUYER') || allowNotCustomers),
				servicesNotificationMessage: rsvp.apImportantMessage,
				frontEndDebug: rsvp.frontEndDebug,
			});
		});
	}

	/**
	 * Pobiera lub wysyła informacje oraz parsuje odpowiedź z JSON-a.
	 * @param url - Adres docelowy
	 * @param obj - Obiekt do przesłania
	 * @param mode - Ustawia metodę w jaki sposób chcemy przesłać informacje
	 */
	async Fetch<T = any>(url: string, obj: any = {}, mode:string = 'GET'): Promise<T> {
		const fetchResult = await serverFetch<T>(url, obj, mode);
		return fetchResult;
	}
}
